export const FIELD_VARIANT = {
  STANDARD: 'standard',
  FILLED: 'filled',
  OUTLINED: 'outlined',
}
